var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-wrapper"},[_c('div',{staticClass:"headline"},[_vm._v("Sitetape")]),_c('div',{staticClass:"version"},[_vm._v("Beta")])])}]

export { render, staticRenderFns }